// ======================================================================
// File Name       : content
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/ActionTypes';

export function receiveSkinListToCache(skinList, institutionId) {
  return {
    type: ActionTypes.CACHE_DRILL_SKIN_LIST,
    skinList,
    institutionId,
  };
}

export function getQuestionListDrillDetail(data) {
  return {
    type: ActionTypes.GET_QUESTION_LIST_DRILL_DETAIL,
    data,
  };
}

//STEP9.0.0 START
export function getDrillQuestionListForSort(groupIndex, drillGroupId) {
  return {
    type: ActionTypes.CONTENT_DRILL_QUESTION_FOR_SORT,
    groupIndex,
    drillGroupId,
  };
}

export function updateDisplayOrderStructureList(structureSecernIdList) {
  return {
    type: ActionTypes.CONTENT_UPDATE_DISPLAY_ORDER_STRUCTURE_LIST,
    structureSecernIdList,
  };
}

export function saveDisplayOrderDrillQuestion() {
  return {
    type: ActionTypes.CONTENT_SAVE_DISPLAY_ORDER_DRILL_QUESTION,
  };
}
//STEP9.0.0 END